import { useState, useRef, useEffect } from "react";
import LocationOptionsMenu from "./LocationOptionsMenu";
import { MenuSVG } from "./SVG";

const EditableLocation = ({
  text,
  onTextChange,
  location,
  onLocationChange,
  style,
  className,
  font,
  color,
  fontSize = 16,
  onStyleChange,
  tag = "p",
  isEditable,
  isBold,
  isItalic,
  coordinates,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [optionsPosition, setOptionsPosition] = useState({ left: 0, top: 0 });
  const editRef = useRef(null);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);

  const handleButtonClick = (e) => {
    // Determine which element to use for positioning
    const targetElement = e.currentTarget || buttonRef.current;
    if (!targetElement) return;

    const rect = targetElement.getBoundingClientRect();
    setOptionsPosition({
      top: rect.bottom + 25,
      left: window.innerWidth / 2,
    });

    setShowOptions((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showOptions]);

  const handleLocationClick = (e) => {
    if (isEditable) {
      handleButtonClick(e);
    }
  };

  const handleLocationChange = (newLocation, newCoordinates) => {
    onLocationChange(newLocation, newCoordinates);
    setShowOptions(false);
  };

  const Tag = tag;

  return (
    <div className="group relative">
      <Tag
        ref={editRef}
        contentEditable={false}
        onClick={handleLocationClick}
        style={{
          ...style,
          fontSize: `${fontSize}px`,
          color,
          fontWeight: isBold ? "bold" : "normal",
          fontStyle: isItalic ? "italic" : "normal",
        }}
        className={`outline-none ${className} ${
          isEditable
            ? "cursor-pointer border-2 border-dashed border-gray-200"
            : ""
        }`}
      >
        {text}
      </Tag>

      {isEditable && (
        <button
          type="button"
          ref={buttonRef}
          onClick={handleButtonClick}
          className="absolute -right-8 top-0 opacity-0 group-hover:opacity-100 transition-opacity bg-teal-600 rounded-full"
        >
          <MenuSVG />
        </button>
      )}

      {showOptions && (
        <div
          ref={optionsRef}
          className="fixed bg-white rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 z-50 transform -translate-x-1/2 h-32"
          style={{
            left: `${optionsPosition.left}px`,
            top: `${optionsPosition.top}px`,
          }}
        >
          <LocationOptionsMenu
            font={font}
            color={color}
            fontSize={fontSize}
            onStyleChange={onStyleChange}
            location={location || text}
            onLocationChange={handleLocationChange}
            isBold={isBold}
            isItalic={isItalic}
          />
        </div>
      )}
    </div>
  );
};

export default EditableLocation;
